const isAttendee = (twilioUser) => {
  const rolesText = twilioUser?.attributes?.roles || '';
  let roles = rolesText.split(',');
  roles = roles.map((role) => role.toLowerCase().trim());
  return roles.includes('attendee');
};

export default isAttendee;
